export default "__VITE_ASSET__WapPnS36__"